import { IDataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation, IEntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { MethodEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Evaluation/MethodEvaluator";
import { Nullable, PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { IControl } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Control";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { PickerDialogCase } from "../Ui/Dialogs/PickerDialogCase";

const
    radWindow = WindowShim();

(radWindow as any).EntityCommandFlaggedCaseEmailSelectCase = {
    visibilityEvaluatorMethod: function (context: Nullable<IControl> | Nullable<IDataSource>, state?: any): boolean
    {
        const
            entityCommandInformation = state as IEntityCommandInformation;

        if (!entityCommandInformation)
            return false;

        const
            caller = entityCommandInformation.caller.get();

        if (!caller)
            return false;

        const
            record = entityCommandInformation.record.get();

        if (!record)
            return false;

        return !record.case;
    },
};

export type EntityCommandFlaggedCaseEmailSelectCasePropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandFlaggedCaseEmailSelectCaseProperties = {
    [name in keyof EntityCommandFlaggedCaseEmailSelectCasePropertyValues]: Property<EntityCommandFlaggedCaseEmailSelectCasePropertyValues[name]>
};

export interface IEntityCommandFlaggedCaseEmailSelectCase extends IEntityCommand, EntityCommandFlaggedCaseEmailSelectCaseProperties
{
}

export class EntityCommandFlaggedCaseEmailSelectCase extends EntityCommand implements IEntityCommandFlaggedCaseEmailSelectCase
{
    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandFlaggedCaseEmailSelectCasePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Select Case",
                entityName: "FlaggedCaseEmail",
                key: "SELECTCASE",
                permission: (PermissionEvaluator.permissionLevels.update ?? 0) + (PermissionEvaluator.permissionLevels.read ?? 0),
                type: EntityCommandTypeEnum.entity,
                visibleEvaluator: new MethodEvaluator({
                    methodPath: "EntityCommandFlaggedCaseEmailSelectCase.visibilityEvaluatorMethod"
                })
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            caller = entityCommandInformation.caller.get();

        if (!caller)
            return;

        const
            record = entityCommandInformation.record.get();

        if (!record)
            return;

        if (!caller.pickerDialogCase)
            caller.pickerDialogCase = new PickerDialogCase();

        const
            pickerDialogCase = caller.pickerDialogCase as PickerDialogCase;

        pickerDialogCase.openAsync()
            .then(result =>
            {
                const
                    selectedItemId = result.promiseData;

                if (result.dialogResult !== DialogResultEnum.ok || !selectedItemId)
                    return;

                const
                    webApiClient = ServiceManager.getRequired(WebApiClientService);

                return (
                    webApiClient
                        .createApiMethodRequest("caseEmail", "associateCase", { id: record.id, caseId: selectedItemId })
                        .executeAsync()
                        .finally(() =>
                        {
                            caller.searchAsync();
                        })
                )
            });
    }

    // #endregion

    // #endregion
}

